export default __webpack_public_path__ + "static/media/ic-menu-vertical.238810dd.svg";